// Can be DEV,UAT,QA LOCAL_HOST,PROD
export const ENVIRONMENT_TYPE: string | undefined = import.meta.env.VITE_REACT_APP_ENV;

// ENVIRONMENT_TYPE !== "PROD" && console.log(import.meta.env);

export const IS_PROD = ENVIRONMENT_TYPE === 'PROD';

interface configInterface {
  baseApiUrl: string;
  ssoUrl: string;
  loginHash: string;
  apiKey: string;
  pmsUrl: string;
  sentryDSN: string;
  globalApi: {
    endPoint: string;
    token: string;
  };
  emqxBrokerConfig: {
    clean: boolean;
    connectTimeout: number;
    clientId: string;
    username: string;
    password: string;
    host: string;
    port: number;
    path: string;
    protocol: 'wss' | 'ws' | 'mqtt' | 'mqtts' | 'tcp' | 'ssl' | 'wx' | 'wxs' | undefined;
  };
  unamiId: string;
}

interface mapInterface {
  LOCAL_HOST: configInterface;
  UAT: configInterface;
  PROD: configInterface;
}

const LOCAL_HOST_CONFIG: configInterface = {
  baseApiUrl: 'http://localhost:4037',
  ssoUrl: 'https://uat-sso.isha.in',
  loginHash: '090dbd1bf20595c05b8cb60516caf0a0dc3bbc8e70ba3198a50f79ab6e4362a5',
  apiKey: 'w05.events-sadhguru-rlfuvonhtg',
  pmsUrl: 'https://uat-profile.isha.in/services/pms',
  sentryDSN: 'xxx',
  globalApi: {
    endPoint: 'https://uat-gapi.sadhguru.org',
    token: 'hmCbkUB4rHuRt2x2YMZ9QdpPFrgw3dqPUjpTbNtD6phPLjJKyqsXjtPzJAayusLd',
  },
  emqxBrokerConfig: {
    clean: true,
    connectTimeout: 4000,
    clientId: '',
    username: 'ipd_user',
    host: 'uat-emqx.sadhguru.org',
    path: '/mqtt',
    port: 443,
    protocol: 'wss',
    password: '',
  },
  unamiId: 'xyzabc',
};

const UAT_CONFIG: configInterface = {
  baseApiUrl: 'https://uipd-user-api.sadhguru.org',
  ssoUrl: 'https://uat-sso.isha.in',
  loginHash: '3ae2a7413d1e52444e2dbc02adda0a816af44409455a6a6d7780a4635782f920',
  apiKey: 'w05.events-sadhguru-rlfuvonhtg',
  pmsUrl: 'https://uat-profile.isha.in/services/pms',
  sentryDSN:
    'https://ee74992a04af22092085c500e861ef6b@o665977.ingest.sentry.io/4506693186289664',
  globalApi: {
    endPoint: 'https://uat-gapi.sadhguru.org',
    token: 'hmCbkUB4rHuRt2x2YMZ9QdpPFrgw3dqPUjpTbNtD6phPLjJKyqsXjtPzJAayusLd',
  },
  emqxBrokerConfig: {
    clean: true,
    connectTimeout: 4000,
    clientId: '',
    username: 'ipd_user',
    host: 'uat-emqx.sadhguru.org',
    path: '/mqtt',
    port: 443,
    protocol: 'wss',
    password: '',
  },
  unamiId: 'ae5ab1bf-5512-4cb6-a228-b5cb121a1210',
};

const PROD_CONFIG: configInterface = {
  baseApiUrl: 'https://events-user-api.sadhguru.org',
  ssoUrl: 'https://ishalogin.sadhguru.org',
  loginHash: 'f7fc3bfa576c9748f612c87d1770786d9701f923207da6795c37dd2f8f0a359b',
  apiKey: '3Saf.events-sadhguru-nid8803rylskz9fkvajc391t3n178eyb6ab9hy32a45vyazu',
  pmsUrl: 'https://pms.sadhguru.org/services/pms',
  sentryDSN:
    'https://ee74992a04af22092085c500e861ef6b@o665977.ingest.sentry.io/4506693186289664',
  globalApi: {
    endPoint: 'https://vihanga.isha.in',
    token: 'BfcEgbjVffLhkE9xeJWW3hZHTrDPmp79ugfG3Hcgpe73MLAdx5va3mmnqC2ax5d5',
  },
  emqxBrokerConfig: {
    clean: true,
    connectTimeout: 4000,
    clientId: '',
    username: 'ipd_user',
    host: 'emqx.sadhguru.org',
    path: '/mqtt',
    port: 443,
    protocol: 'wss',
    password: '',
  },
  unamiId: 'abc200c7-2465-4bd5-a76b-184d47e81fe7',
};

const CONFIG_MAP: mapInterface = {
  LOCAL_HOST: LOCAL_HOST_CONFIG,
  UAT: UAT_CONFIG,
  PROD: PROD_CONFIG,
};

const selector = () => {
  switch (ENVIRONMENT_TYPE) {
    case 'LOCAL_HOST':
      return CONFIG_MAP.LOCAL_HOST;
    case 'UAT':
      return CONFIG_MAP.UAT;
    case 'PROD':
      return CONFIG_MAP.PROD;
    default:
      return CONFIG_MAP.UAT;
  }
};

export const CONFIG = selector();
